module.exports = "<div>\n    <h1>Dossier : {{ numeroRequete }} </h1>\n</div>\n<h2 *ngIf=\"titre\" class=\"banner-subtitle\">{{titre}}</h2>\n\n<h4>\n    <span class=\"fa fa-map-marker\" aria-hidden=\"true\"></span>\n    Juridiction : {{ siteJuridictionLabel }}\n    <span *ngIf=\"affectation\"> - {{ affectation }}</span>\n</h4>\n"


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/app/requete/requete-title/requete-title.component.html
// module id = 830
// module chunks = 0